import { SubscriptionStatus } from "../../../../OrderFlow/utils/orderFlowUtils";
import { useCompanyConfigQuery } from "../../../../SWR/Company/useCompanyConfigQuery";
import { ORDER_STATUS } from "../../../../Shared/utils/constants";
import { tokenReplace } from "../../../../Shared/utils/tokenReplacement";
import { OrderDetailsText } from "../utils/OrderDetailsAccordion-types";
import { buildForWeekStartingOn, buildMappedMeals, getOrderTotal, getOrderType, getOrderTypeDetails, } from "../utils/orderDetailsUtils";
export const useOrderDetailsAccordion = (currentOrder, skippedDays) => {
    var _a, _b, _c;
    const { culture, tokenMap, orderHistoryCompanyText, startSunday, showPricesIfZero } = useCompanyConfigQuery();
    const orderForWeekStartingOn = buildForWeekStartingOn(currentOrder, startSunday);
    let noMealsSelectedText = (_a = orderHistoryCompanyText["NoMealsSelectedText"]) !== null && _a !== void 0 ? _a : OrderDetailsText.MEALS_NOT_SELECTED;
    noMealsSelectedText = tokenReplace(noMealsSelectedText, true, tokenMap);
    const orderTotal = getOrderTotal(showPricesIfZero, currentOrder, culture);
    const orderIsSkipped = ((_b = currentOrder.order.OrderMealDays) === null || _b === void 0 ? void 0 : _b.length) === 0 && ((_c = currentOrder.orderInfo.product_items) === null || _c === void 0 ? void 0 : _c.length) === 0;
    const mappedMeals = buildMappedMeals(currentOrder, skippedDays, noMealsSelectedText);
    const orderTypeInfo = getOrderType(currentOrder);
    const orderTypeDetails = getOrderTypeDetails(currentOrder);
    const showSubscriptionLinkId = currentOrder.order.OrderStatus === ORDER_STATUS.FUTURE ||
        currentOrder.order.SubscriptionStatus !== SubscriptionStatus.None;
    return {
        orderForWeekStartingOn,
        orderTotal,
        orderIsSkipped,
        mappedMeals,
        orderTypeInfo,
        orderTypeDetails,
        showSubscriptionLinkId,
        showPricesIfZero,
    };
};
